import { IonContent } from '@ionic/react';
import React from 'react';

import { useAccount } from '@/hooks/useAccount.ts';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { userService } from '@/services/user';
import { trackOnboardingComplete } from '@/utils/analytics';
import { canLogEvents } from '@/utils/canLogEvents.ts';
import { preloadImage } from '@/utils/preloadImage.ts';

import { ChatContent } from '../../../screens/MenInteractiveChat/components/ChatContent';
import { Header } from '../../../screens/MenInteractiveChat/components/Header';

import { PageStyles } from './InteractiveChat.styles.ts';

export const ScreenInteractiveChat: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'InteractiveChat',
      });
    }
    preloadImage('../assets/boy-message-img.png');
  }, []);

  const { refreshUser } = useAccount();

  const handleNextStep = async (): Promise<void> => {
    try {
      trackOnboardingComplete();

      await userService.createOrUpdate({
        onboarding_data: {
          onboarded: true,
        },
      });

      refreshUser();
    } catch (error) {
      console.error('Can not create a user', error);
    }
  };

  const [canNextStep, setCanNextStep] = React.useState<boolean>(false);

  return (
    <PageStyles
      background="none"
      bgImage={
        <img src={'../assets/chat-pattern-light.png'} alt="Chat Pattern" />
      }
      bgImageMask={false}
    >
      <IonContent>
        <Header />
        <ChatContent
          onChatEnd={() => {
            setCanNextStep(true);
          }}
        />
      </IonContent>

      {canNextStep && (
        <OnboardingFooter
          buttonText="Let’s do it"
          onContinue={handleNextStep}
        />
      )}
    </PageStyles>
  );
};

export const screenInteractiveChatImages = [
  '../assets/chat-pattern-light.png',
  '../assets/avatar-icon-online-man.png',
  '../assets/boy-message-img.png',
];
